export default function Component(props) {
  return (
    <input
      type={props.type || 'text'}
      className={`form-control shadow-none px-3 py-2 fw-medium ${props.className}`}
      value={props.value}
      id={props.idname}
      name={props.idname}
      placeholder={props.placeholder}
      onChange={(el) => {
        el.preventDefault();
        props.onChange(el.target.value);
      }}
      required
    />
  );
};